import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { fetchData } from "../../helpers/getData/fetchData";
import { OpportunitiesTable } from "./";
import CircularProgress from "@mui/material/CircularProgress";
import { Stack } from "@mui/system";
import { useSelector } from "react-redux";
import { OpportunitiesSmallTable } from "./OpportunitiesSmallTable";
import { Divider, Hidden, Typography } from "@mui/material";

export const GetOpportunitiesAdmin = () => {
  const { role, id } = useSelector((state) => state.auth);
  const { t } = useTranslation("global");
  const [opportunitiesList, setOpportunitiesList] = useState("isLoading");
  const [reservationList, setReservationList] = useState("isLoading");
  const [rows, setRows] = useState("isLoading");
  const [vehiclesList, setVehicles] = useState("isLoading");
  const [reloadData, setReloadData] = useState(false);

  const filterRows = () => {
    const today = new Date();
    const formattedToday = today.toISOString().split("T")[0];
    return rows.filter((row) => {
      return row.dateOpportunity <= formattedToday;
    });
  };

  useEffect(() => {
    fetchData(setOpportunitiesList, "/opportunities", t);

    fetchData(setReservationList, "/reservation", t);
    role === "Admin"
      ? fetchData(setVehicles, "/vehicle/nameList", t)
      : setVehicles([]);
  }, [reloadData, t, role]);

  useEffect(() => {
    if (opportunitiesList !== "isLoading" && reservationList !== "isLoading") {
      const oportunityListVisibility =
        role === "Admin"
          ? opportunitiesList
          : opportunitiesList.filter((op) =>
              JSON.parse(op.visibility)?.includes(id)
            );
      const idList = reservationList.map((a) => a.opportunityId);
      const listWhitMyStatus = oportunityListVisibility.map((opp) => {
        const intention = reservationList.find(
          (a) => a.opportunityId === opp.id
        )?.intention
          ? reservationList.find((a) => a.opportunityId === opp.id).intention
          : "noanswer";
        return idList?.includes(opp.id)
          ? {
              ...opp,
              myStatus: t(`opportunities.${intention}`),
              amount: reservationList.find((a) => a.opportunityId === opp.id)
                .amount,
            }
          : { ...opp, myStatus: t("opportunities.noanswer") };
      });
      setRows(listWhitMyStatus);
    }
  }, [reservationList, opportunitiesList, t, id, role]);

  return (
    <>
      {rows !== "isLoading" && vehiclesList !== "isLoading" ? (
        <>
          <OpportunitiesTable
            rows={role === "Admin" ? rows : filterRows()}
            setReloadData={setReloadData}
            vehiclesList={vehiclesList}
          />
          {(role === "Híbrido" || role === "Club") && (
            <Hidden mdUp>
              <Stack>
                <Stack mb={4}>
                  <Typography
                    variant="subtitle1"
                    color="primary"
                    marginRight="10px"
                  >
                    {t("tablestitles.opportunities")}
                  </Typography>
                  <Divider sx={{ marginTop: "10px" }} />
                </Stack>
                <OpportunitiesSmallTable
                  rows={role === "Admin" ? rows : filterRows()}
                />
              </Stack>
            </Hidden>
          )}
        </>
      ) : (
        <Stack width="100%" alignItems="center" marginTop="100px">
          <CircularProgress />
        </Stack>
      )}
    </>
  );
};
